import React, { memo, useState } from 'react'
import { Select, ISelectOption } from 'components/forms/Selects'
import { ONLY_BID_ON_OPTIONS } from 'apps/spot-quote-control-panel/constants/spotBiddingConfig'
import {
  CONDITION_QUALIFIER,
  IOnlyBidOnCriteria,
  ISpotBiddingRule,
  ONLY_BID_ON_CRITERIA,
} from 'apps/spot-quote-control-panel/types/spotBiddingConfig'

interface IRuleOptionProps {
  value?: RecursivePartial<IOnlyBidOnCriteria>
  rule: RecursivePartial<ISpotBiddingRule>
  onChange(change: RecursivePartial<ISpotBiddingRule>): void
  error?: string
}

export const OnlyBidOnOption = memo<IRuleOptionProps>(
  ({ error, onChange, rule, value: onlyBidOnCriteria }) => {
    const { isDrop, isMultiStop, isSameDay, isWeekend } = onlyBidOnCriteria || {}
    const initialCriteria = (() => {
      if (isDrop) {
        return ONLY_BID_ON_CRITERIA.drop
      }
      if (isSameDay) {
        return ONLY_BID_ON_CRITERIA.sameDay
      }
      if (isWeekend) {
        return ONLY_BID_ON_CRITERIA.weekend
      }
      if (isMultiStop) {
        return ONLY_BID_ON_CRITERIA.multiStop
      }
      return ''
    })()

    const [criteriaType, setCriteriaType] = useState(initialCriteria)

    const ruleTypeHandler = (e: ISelectOption<ONLY_BID_ON_CRITERIA>) => {
      if (e.value) {
        setCriteriaType(e.value)
        const qualifier = rule.conditionQualifier !== CONDITION_QUALIFIER.isNot
        onChange({
          onlyBidOnCriteria: {
            isDrop: e.value === ONLY_BID_ON_CRITERIA.drop ? qualifier : null,
            isMultiStop: e.value === ONLY_BID_ON_CRITERIA.multiStop ? qualifier : null,
            isSameDay: e.value === ONLY_BID_ON_CRITERIA.sameDay ? qualifier : null,
            isWeekend: e.value === ONLY_BID_ON_CRITERIA.weekend ? qualifier : null,
          },
        })
      }
    }

    return (
      <div className='col-md-6 col-xs-4'>
        <Select
          label='Condition'
          placeholder='Condition'
          options={ONLY_BID_ON_OPTIONS}
          value={criteriaType}
          onChange={ruleTypeHandler}
          dataTest='modal-rule-option'
          validationMessage={error}
          invalid={!!error}
          required
          large
        />
      </div>
    )
  }
)
